import { Amplify } from 'aws-amplify';
import amplifyConfig from './amplify-config.json';
export function configureAmplifyForLiveness() {
  Amplify.configure(amplifyConfig);
}

